import React from "react"
import { StyleSheet, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"

export const ChangePlanBottomModalSection = ({
    icon,
    title,
    rightContent,
    children,
    // Marges optionnelles. Elles existent pour l'écran de configuration du
    // funnel, où la page ne porte AUCUNE marge : chaque bloc pose la sienne, de
    // sorte que les rangées de cartes qui défilent horizontalement aillent
    // vraiment jusqu'au bord de l'écran. On peut donc décaler l'en-tête sans
    // décaler le contenu.
    style,
    headerStyle,
}) => {
    return (
        <View style={[styles.section, style]}>
            <View style={[styles.row, styles.wrapRow, headerStyle]}>
                <View style={styles.row}>
                    <FontAwesome5 name={icon} color={theme.colors.primary} />
                    <TextM fontWeight="medium">{title}</TextM>
                </View>
                {rightContent}
            </View>
            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    section: {
        gap: 14,
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
    },
    wrapRow: {
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
})
